import { Alert } from "antd";
import { Checkbox, Modal, Select, Timeline } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { SaveButton } from "~/components/buttons/SaveButton.jsx";
import { SluitButton } from "~/components/buttons/SluitButton.jsx";
import { VerwijderButton } from "~/components/buttons/VerwijderButton.jsx";
import { config } from "~/config.js";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";

function successGuestRemove(onOk) {
  Modal.success({
    title: $t("Club verwijderd"),
    content: $t(
      "We hebben de club verwijderd."
    ),
    onOk,
  });
}

export const CardGuestClubRemoveModal = ({
  onClose,
  guest_club
}) => {
  const [shareOK, setShareOK] = useState(false);
  const [htOK, setHtOK] = useState(false);

  const dispatch = useDispatch();

  const [saving, setSaving] = useState(false);
  const saveClub = async () => {
    setSaving(true);
    const data = await api.post("gegevens/remove_guest_club.json", {club: guest_club.club, user_id: guest_club.user_id});

    setSaving(false);

    if (data) {
      dispatch({
        type: "SET_PROFILE",
        profile: data,
      });
      successGuestRemove(onClose);
    }
  };

  return (
    <Modal
      open={!!guest_club}
      title={$t("Deactiveer gastclub")}
      onCancel={onClose}
      footer={[
        <SluitButton key="cancel" onClick={onClose} disabled={saving} />,
        <VerwijderButton
          key="save"
          onClick={saveClub}
          disabled={!shareOK || !htOK}
          loading={saving}
        />,
      ]}
    >
      
      <Timeline>
        <Timeline.Item
          style={{ cursor: "pointer" }}
          onClick={() => setShareOK(!shareOK)}
          dot={<Checkbox checked={shareOK} />}
          color={shareOK ? "green" : "blue"}
        >
          <span>
            {$t(
              "Ik ga ermee akkoord dat de koppeling met de gastclub '${club}' verwijderd wordt.", {club: guest_club.full_name}
            )}
          </span>
        </Timeline.Item>

        <Timeline.Item
          style={{ cursor: "pointer" }}
          onClick={() => setHtOK(!htOK)}
          dot={<Checkbox checked={htOK} />}
          color={htOK ? "green" : "blue"}
        >
          <span>
            {$t(
              "Ik ben me ervan bewust dat na deactivering mijn gegevens bij de gastclub nog 3 jaar zichtbaar blijven volgens EASA-vereisten."
            )}
          </span>
        </Timeline.Item>
      </Timeline>
    </Modal>
  );
};
